export const resources = {
  UseScenarioLabel: '',
  PresetCustomViewTitle: '',
  View: '',
  Presets: '',
  LabelCustomInsightsPresetButton: ''
};
